import { format, subMonths } from 'date-fns';

const actionsToFormat = ['FETCHING_FACEBOOK_PAGE_IMPRESSIONS_SUCCESS', 'FETCHING_FACEBOOK_PAGE_VIDEO_VIEWS_SUCCESS', 'FETCHING_FACEBOOK_LIKES_AND_PAGE_VIEWS_SUCCESS', 'FETCHING_FACEBOOK_SOURCE_AND_PAID_NON_PAID_DATA_SUCCESS'];

const prevMonth = format(subMonths(new Date(), 1), 'MMM');

export const crm_social_middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (actionsToFormat.includes(action.type)) {
      const payloadData = action.payload.data;
      const endDatesFormatted = (payloadData || []).map((item) => {
        const valuesFormatted = (item.values || []).map((item) => {
          item.end_time_formatted = format(new Date(item.end_time), 'MMM');

          if (item.end_time_formatted === prevMonth) {
            item.isCurrentMonth = true;
          }
          return item;
        });
        item.values = valuesFormatted;
        return item;
      });
      action.payload.data = endDatesFormatted;
    }
    next(action);
  };
